// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"CarouselArrow_wrapper__yBi1U","arrow":"CarouselArrow_arrow__kpDjY","next":"CarouselArrow_next__hLIY2","previous":"CarouselArrow_previous__EOVXS"};